import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import SimpleBar from "simplebar-react";
import { getAllUnReadNotifications } from "../../../http/fundLync/notificationHelper";
//Import images

//i18n
import { withTranslation } from "react-i18next";
import { decryptedValue } from 'common/utility';

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);




  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };

    return dateTime.toLocaleString('en-US', options);
  };

  useEffect(() => {
    const user = decryptedValue(localStorage.getItem("user"));
    getAllUnReadNotifications({ userId: user.id, limit: 5 })
      .then((response) => {
        setNotifications(response.data.data)
        setNotificationCount(response.data.totalItems)
      })
      .catch((error) => {

      });

  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
        direction="up"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" style={{ fontSize: "27px" }} />
          <span className="badge bg-danger rounded-pill">{notificationCount}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg  p-0 notification_container"
          style={{ width: "350px" }}
        >
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <Link to="/notifications" className="small"
                  onClick={()=> setMenu(!menu)}
                >
                  {" "}
                  View More
                </Link>
              </div>
            </Row>
          </div>
          <SimpleBar style={{ height: '230px' }}>
            {notifications.map((item) => (
              <Link key={item.id} to="/notifications" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">{item.notificationHeader}</h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" /> {formatDateTime(item.createdAt)}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </SimpleBar>
          <div className='pt-2'></div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};